<template>
  <div>
    <v-btn
      class="ma-2 no-display"
      tile
      outlined
      color="warning"
      @click="print()"
    >
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>
    <div id="document1" class="printdiv cbse" v-if="lc_data != null">
      <div class="header">
        <div>
          <div style="background-color: rgb(248, 246, 226)">
            <v-row style="display: flex; height: 180px;">
              <!-- <v-col cols="3" class="inside-header header-row">
                <div>
                  <center>
                    <img
                      :src="org_basic_data.school_logo"
                      alt="school_logo"
                      height="120px"
                      width="170px"
                    />
                  </center>
                </div>
                <center
                  class="tdata2"
                  style="text-transform: uppercase; color: rgb(9, 9, 87)"
                >
                  {{ org_basic_data.school_name }}
                </center>
              </v-col>
              <v-col cols="6" sm="6" md="6" class="inside-header header-row">
                <div style="text-align: center">
                  <p>{{ org_basic_data.trust_name }}</p>
                  <h1 class="header-style">
                    Sanjivani <span class="span-first-letter">A</span>cademy
                  </h1>
                  <p>
                    {{ org_basic_data.address }} Pin - {{ org_basic_data.pin }}
                  </p>
                  <p>Phone: {{ org_basic_data.phone }}</p>
                  <p>Email:{{ org_basic_data.email }},</p>
                  <p>Website: {{ org_basic_data.website }}</p>
                </div>
              </v-col>
              <v-col cols="3" class="align-center tdata2 header-row">
                <span>CBSE Affiliation No. : {{ org_basic_data.cbsc_no }}</span
                ><br />
                <span>School Code No. : 30529</span><br />
                <span>U-DISE No. : {{ lc_data.udise_no }}</span>
              </v-col> -->
            </v-row>
            <hr style="border: 1px solid black" />
          </div>
          <v-col
            cols="12"
            md="12"
            sm="12"
            style="padding: 0px; font-family: 'Times New Roman', Times, serif"
          >
            <v-row dense class="last-row">
              <v-col cols="auto">
                <span class="tdata2">L.C.No: {{ lc_data.certificate_no }}</span>
                <br />
              </v-col>
              <v-col cols="auto">
                <span class="tdata2 text-right"
                  >GR. No. {{ lc_data.gr_number }}</span
                >
              </v-col>
            </v-row>
          </v-col>

          <center>
            <h2 class="heading">LEAVING CERTIFICATE</h2>
          </center>
        </div>
      </div>
      <div class="lcdata">
        <span
          ><center>
            (No Changes in any entry is to be made except by the authority
            issuing the certificate)
          </center>
        </span>
        <br />
        <!-- lc table content  -->
        <div class="content">
          <table class="page">
            <tbody>
              <tr>
                  <td>PEN ID</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.pen_no }}</td>
                </tr>
              <tr>
                  <td>APAAR ID</td>
                  <td>:</td>
                  <td class="tdata2">{{ lc_data.apaar_id }}</td>
                </tr>
              <tr>
                <td>Name of the pupil in full</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.fullname }}</td>
              </tr>
              <tr>
                <td>Father's Full Name</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.father_full_name }}</td>
              </tr>
              <tr>
                <td>Mother's Name</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.mother_first_name }}</td>
              </tr>
              <tr>
                <td>Religion, Caste & Sub Caste</td>
                <td>:</td>
                <td class="tdata2">
                  {{ lc_data.religion }} - {{ lc_data.caste }}-
                  {{ lc_data.subcaste }}
                </td>
              </tr>
              <tr>
                <td>Nationality</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.nationality }}</td>
              </tr>
              <tr>
                <td>Place of Birth</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.birth_place }}</td>
              </tr>
              <tr>
                <td>Date of Birth in figure & words</td>
                <td>:</td>
                <td class="tdata2">
                  {{ lc_data.dob_fig }} ({{ lc_data.dob_words }})
                </td>
              </tr>
              <tr>
                <td>Last School Attended</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.last_school }}</td>
              </tr>
              <tr>
                <td>Date of Admission in & class</td>
                <td>:</td>
                <td class="tdata2">
                  {{ lc_data.doa }} ({{ lc_data.admittedstandard }})
                </td>
              </tr>
              <tr>
                <td>School Annual Examination with result</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.result_status }}</td>
              </tr>
              <tr>
                <td>Progress in Studies</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.progress }}</td>
              </tr>
              <tr>
                <td>Conduct in School</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.conduct }}</td>
              </tr>
              <tr>
                <td>Date of Application for Certificate</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.date_of_application }}</td>
              </tr>
              <tr>
                <td>Date of issue of certificate</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.date_of_issue }}</td>
              </tr>
              <tr>
                <td>Standard in which pupil was studying</td>
                <td>:</td>
                <td class="tdata2">
                  {{ lc_data.standard }}
                </td>
              </tr>
              <tr>
                <td>Reason of Leaving School</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.reason }}</td>
              </tr>
              <tr>
                <td>Remark</td>
                <td>:</td>
                <td class="tdata2">{{ lc_data.remark }}</td>
              </tr>
            </tbody>
          </table>
          <!-- lc table end -->
          <hr style="border: 1px dashed black; width: 90%; margin: auto" />
          <div style="margin-left: 5%; margin-right: 5%">
            <span class="tdata2 ml-2 font-size"
              >Certified that above Mentioned information is True According to
              the School General Register.
            </span>

            <v-row dense class="place-and-date-row pt-1">
              <v-col class="pl-5" cols="6">
                <span class="tdata2">Place: Khirdi Ganesh, Kopargaon</span>
                <br />
              </v-col>
              <v-col cols="6" align="right">
                <span class="tdata2">Date : {{ lc_data.gen_date }}</span>
              </v-col>
            </v-row>
          </div>
          <br />
          <br />
          <v-row class="mt-10 tdata2 font-size">
            <v-col cols="4" align="center"><span>Prepared By</span> </v-col>
            <v-col cols="4" align="center">
              <span>Class Teacher</span>
            </v-col>
            <v-col cols="4" align="center">
              <span>Principal</span>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      lc_data: null,
      org_basic_data: null,
      org_id: null,
    };
  },

  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
  },
  mounted() {
    this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
    this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
    this.org_id = localStorage.getItem("EPS-org-id");
  },
};
</script>
<style scoped>
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: rgb(248, 248, 241);
  background-position: center;
}
.header {
  margin: 6px;
}
.tdata2 {
  font-weight: bolder;
}
.last-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  /* margin-bottom: -15px; */
}
.page {
  margin-left: 60px;
  margin-top: 0px;
  border: none !important;
}
.lcdata {
  font-family: "Times New Roman", Times, serif;
}
.content {
  padding-bottom: 10px;
}
.heading {
  letter-spacing: 1px;
  text-decoration: underline;
  font-family: "Times New Roman", Times, serif;
}
.inside-header {
  border-right: 1px solid black;
  height: auto;
}
.header-row {
  padding-top: 15px;
}
.header-style {
  font-family: serif;
  color: rgb(151, 17, 17);
}
.header-style::first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
.header-style .span-first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
.align-center {
  padding-top: 50px;
  font-size: medium;
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(235, 61, 61);
}
.page tr,
.page td {
  font-size: large;
  text-align: left;
  border: none !important;
}
/* lc data css end */

/* print lc css */
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  p,
  .align-center {
    font-size: 17px !important;
  }
  .header-style {
    font-size: 40px !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
  }
  .cbse {
    margin-left: -15px !important;
    width: 102%;
  }
  .page {
    line-height: 200% !important;
  }
  #document1 {
    position: absolute;
    /* margin-top: -63px; */
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .place-and-date-row,
  .font-size {
    font-size: 22px !important;
  }
  @page {
    size: A4;
    margin: none;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */
</style>